// @ts-nocheck
import {Column} from 'react-table'
import {UserInfoCell} from './UserInfoCell'
import {UserTwoStepsCell} from './UserTwoStepsCell'
import {UserSelectionCell} from './UserSelectionCell'
import {UserCustomHeader} from './UserCustomHeader'
import {UserSelectionHeader} from './UserSelectionHeader'
import {User} from '../../core/_models'
import UserPhoneNumberCell from './UserPhoneNumberCell'
import UserGenderCell from './UserGenderCell'
import UserLocationCell from './UserLocationCell'
import {UserStatusCell} from './UserStatusCell'
import {UserActionsCell} from './UserActionsCell'
import UserDateCell from './UserDateCell'
import {InstructorInfoCell} from './InstructorInfoCell'
import UserAmountCell from './UserAmountCell'

const usersColumns: ReadonlyArray<Column<User>> = [
  // {
  //   Header: (props) => <UserSelectionHeader tableProps={props} />,
  //   id: '_id',
  //   accessor: '_id',
  //   Cell: ({...props}) => <UserSelectionCell id={props.data[props.row.index]._id} />,
  // },

  {
    Header: (props) => <UserCustomHeader tableProps={props} title='User' className='min-w-125px' />,
    id: 'user',
    accessor: 'user',
    Cell: ({...props}) => <InstructorInfoCell user={props.data[props.row.index].user} />,
  },

  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Transaction Id' className='min-w-125px' />
    ),
    id: '_id',
    accessor: '_id',
    Cell: ({...props}) => <UserPhoneNumberCell phone={props.data[props.row.index].stripeId} />,
  },

  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Amount' className='min-w-125px' />
    ),
    id: 'amount',
    accessor: 'amount',
    Cell: ({...props}) => <UserAmountCell amount={props.data[props.row.index].amount} />,
  },

  // {
  //   Header: (props) => (
  //     <UserCustomHeader tableProps={props} title='End Time' className='min-w-125px' />
  //   ),
  //   id: 'endTime',
  //   accessor: 'endTime',
  //   Cell: ({...props}) => <UserDateCell phone={props.data[props.row.index].endTime} />,
  // },

  {
    Header: (props) => <UserCustomHeader tableProps={props} title='Date' className='min-w-125px' />,
    id: 'createdAt',
    accessor: 'createdAt',
    Cell: ({...props}) => <UserDateCell phone={props.data[props.row.index].createdAt} />,
  },

  // {
  //   Header: (props) => (
  //     <UserCustomHeader tableProps={props} title='Email' className='min-w-125px' />
  //   ),
  //   id: 'email',
  //   accessor: 'email',
  //   Cell: ({...props}) => <UserGenderCell gender={props.data[props.row.index].email} />,
  // },
  // {
  //   Header: (props) => (
  //     <UserCustomHeader tableProps={props} title='Type' className='min-w-125px' />
  //   ),
  //   id: 'role',
  //   accessor: 'role',
  //   Cell: ({...props}) => <UserLocationCell phone={props.data[props.row.index].role} />,
  // },

  // {
  //   Header: (props) => (
  //     <UserCustomHeader tableProps={props} title='Status' className='min-w-125px' />
  //   ),
  //   id: 'isBlocked',
  //   accessor: 'isBlocked',
  //   Cell: ({...props}) => <UserStatusCell isBlocked={props.data[props.row.index].isBlocked} />,
  // },

  // {
  //   Header: (props) => (
  //     <UserCustomHeader tableProps={props} title='Location' className='min-w-125px' />
  //   ),
  //   id: 'primaryLocation',
  //   accessor: 'primaryLocation',
  //   Cell: ({...props}) => <UserLocationCell phone={props.data[props.row.index].primaryLocation} />,
  // },

  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Actions' className='text-end min-w-100px' />
    ),
    id: 'actions',
    Cell: ({...props}) => <UserActionsCell id={props.data[props.row.index]._id} />,
  },
]

export {usersColumns}
